
import { Component, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
import { setFocusToInput } from '@/utils/functions';
import { zawaroom } from '@/utils/models';

@Component({ components: { Popup } })
export default class SetPasswordPopup extends Vue {
  public passwordToSet = '';
  @Prop() private isVisible!: boolean;

  private onSetPasswordButtonClick(): void {
    // zawaroom.activeRoom.lock(this.passwordToSet)
    //     .then(() => console.log('New password set'))
    //     .catch((e: any) => {
    //       console.log('Couldn\'t set new password, you\'re not a moderator');
    //     });
    // this.hideSetPasswordPopup();
  }

  private hideSetPasswordPopup(): void {
    this.$emit('close');
  }

  private init(): void {
    setFocusToInput(this.$refs.popupInputRef);
  }
}
